import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { whatsappHref } from "../../data/content";

// Mobile-only floating WhatsApp CTA. Appears after the hero has scrolled past.
export const StickyWhatsApp = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > window.innerHeight * 0.6);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.a
          key="sticky-wa"
          href={whatsappHref()}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Chat with us on WhatsApp"
          data-testid="sticky-whatsapp-btn"
          initial={{ opacity: 0, y: 24, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 24, scale: 0.9 }}
          transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          className="lg:hidden fixed bottom-5 right-5 z-[60] inline-flex items-center gap-2 rounded-full bg-[#25D366] text-white pl-3 pr-4 py-3 shadow-[0_10px_30px_-8px_rgba(37,211,102,0.55)] active:scale-95 transition-transform"
        >
          <span className="relative flex h-9 w-9 items-center justify-center rounded-full bg-white/15">
            <span className="absolute inset-0 rounded-full bg-white/30 animate-ping" />
            <MessageCircle size={20} strokeWidth={2.2} className="relative" />
          </span>
          <span className="font-body text-[12px] tracking-[0.18em] uppercase font-medium">
            Chat
          </span>
        </motion.a>
      )}
    </AnimatePresence>
  );
};
